import { Box, Button, Chip, CircularProgress, Grid, IconButton, Typography } from '@mui/material'
import SimpleModal from 'src/Component/SimpleModal'
import useEditParentGym from './useEditParentGym'
import InputField from 'src/Component/InputField'
import { Controller } from 'react-hook-form'
import FileInput from 'src/Component/FileInput'
import editIconRedBg from 'src/assets/icons/editIconRedBg.png'
type EditParentGymModalProps = {
  id: number
  open: boolean
  onClose: () => void
  successCallback: () => void
  onDeleteClick: (id: number) => void
}
const EditParentGymModal = ({
  id,
  open,
  onClose,
  successCallback,
  onDeleteClick,
}: EditParentGymModalProps) => {
  const {
    file,
    handleFileChange,
    control,
    errors,
    onSubmit,
    isLoadingEditParentGym,
    imageUrl,
    showUploadImage,
    handleShowUploadImage,
  } = useEditParentGym({
    successCallback,
    id,
  })

  return (
    <Box>
      <SimpleModal open={open} onClose={onClose}>
        <form onSubmit={onSubmit}>
          <Box>
            {showUploadImage || !imageUrl ? (
              <FileInput
                type='image'
                title='You can click me to upload files!'
                discription='Support for  image file formats (.png, .jpeg)'
                name='fileuplaod'
                value={file}
                onChange={handleFileChange}
                showPreview
              />
            ) : (
              <Box textAlign='center' position='relative' minHeight='50px'>
                <img
                  src={imageUrl}
                  style={{
                    width: '100%',
                    height: '250px',
                    objectFit: 'cover',
                  }}
                />
                <Box
                  sx={{
                    position: 'absolute',
                    right: 0,
                    bottom: 0,
                  }}
                >
                  {' '}
                  <IconButton onClick={handleShowUploadImage}>
                    <img src={editIconRedBg} />
                  </IconButton>
                </Box>
              </Box>
            )}

            <Grid container mt={3}>
              <Grid xs={8} mb={2}>
                <Controller
                  name='name'
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <>
                      <InputField
                        name={field.name}
                        type='text'
                        label='Name'
                        placeholder='Enter ParentGym name'
                        value={field.value}
                        onChange={field.onChange}
                        error={!!errors.name}
                        required
                      />
                      {!!errors.name && (
                        <Typography variant='subtitle2' color='red' textAlign='right'>
                          {errors.name.message}
                        </Typography>
                      )}
                    </>
                  )}
                />
              </Grid>
            </Grid>
            <Button
              variant='contained'
              color='secondary'
              type='submit'
              disabled={isLoadingEditParentGym}
            >
              {isLoadingEditParentGym ? <CircularProgress size={25} color='error' /> : 'SAVE'}
            </Button>
            <Button
              onClick={() => onDeleteClick(id)}
              sx={{ marginLeft: '20px' }}
              variant='contained'
              color='primary'
              type='button'
            >
              DELETE
            </Button>
          </Box>
        </form>
      </SimpleModal>
    </Box>
  )
}

export default EditParentGymModal
